import { ClientActions } from './actions';

export interface ClientState {
  currentClient: string | undefined;
}

const initialState = {
  currentClient: undefined,
};

export function clientReducer(
  state: ClientState = initialState,
  action: ClientActions,
) {
  switch (action.type) {
    case 'CLIENT.SET_CURRENT':
      return {
        ...state,
        currentClient: action.payload,
      };
    default:
      return state;
  }
}

export const CLIENT_MODULE_KEY: 'client' = 'client';
export type ClientGlobalState = { [CLIENT_MODULE_KEY]: ClientState };
